// removed by extract-text-webpack-plugin
module.exports = {"Banner":"_3tGhFZxq0DF0qDLPStJxW4"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/Banner/style.css
// module id = 1877
// module chunks = 0